module.exports = __webpack_public_path__ + "static/media/radio.bb1dbb23.svg";